import React, { useMemo, useRef, useState } from 'react';
import * as d3 from 'd3';
 
type DataItem = {
  label: string;
  value: number;
  color: string;
};
 
type DonutChartProps = {
  width: number;
  height: number;
  data: DataItem[];
};
 
const MARGIN = 50;
 
export const PieChart = ({ width, height, data }: DonutChartProps) => {
  const radius = Math.min(width, height) / 2 - MARGIN;
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
 
  const pie = useMemo(() => {
    const pieGenerator = d3
      .pie<any, DataItem>()
      .value((d) => d.value)
      .padAngle(0.01);
    return pieGenerator(data);
  }, [data]);
 
  const arcGenerator = d3
    .arc<any>()
    .innerRadius(0)
    .outerRadius(radius)
    .cornerRadius(4);
 
  const tooltipRef = useRef<any>(null);
 
  return (
    <div style={{ position: 'relative' }}>
      <svg
        width={width}
        height={height}
        style={{ display: 'inline-block' }}
        onMouseMove={(event) => {
          const mouseX = event.nativeEvent.offsetX;
          const mouseY = event.nativeEvent.offsetY;
          if (tooltipRef.current) {
            tooltipRef.current.style.left = `${mouseX}px`;
            tooltipRef.current.style.top = `${mouseY}px`;
          }
        }}
        onMouseLeave={() => {
          if (tooltipRef.current) {
            tooltipRef.current.style.visibility = 'hidden';
          }
          setHoveredIndex(null);
        }}
      >
        <g transform={`translate(${width / 2}, ${height / 2})`}>
          {pie.map((arc, i) => (
            <g
              key={i}
              onMouseEnter={() => {
                setHoveredIndex(i);
                if (tooltipRef.current) {
                  tooltipRef.current.style.visibility = 'visible';
                }
              }}
            >
              <path
                d={arcGenerator(arc) || ''}
                fill={hoveredIndex === i ? '#ddd' : arc?.data?.color}
                style={{ transition: 'fill 0.5s ease-in-out' }}
              />
            </g>
          ))}
        </g>
      </svg>
      {hoveredIndex !== null && (
        <div
          ref={tooltipRef}
          style={{
            position: 'absolute',
            visibility: 'hidden',
            backgroundColor: '#fff',
            padding: '8px',
            fontWeight: 500,
            fontSize: 12,
            borderRadius: '4px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
            pointerEvents: 'none',
          }}
        >
          {`${data[hoveredIndex].label}: ${data[hoveredIndex].value}`}
        </div>
      )}
    </div>
  );
};
 